// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestStar {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }

    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        const star = new vf.gui.Polygon();
        star.style.left = 400;
        star.style.top = 300;
        star.lineColor = 0xff0000;
        star.lineWidth = 1;
        star.triangleNum = 6;
        star.rotation = 0;
        star.width = 100;
        star.height = 100;

        uiStage.addChild(star);



        this.getButton('设置/取消width/height', () => {
            if (star.width === 200) {
                star.width = 100;
                star.height = 100;
            } else {
                star.width = 200;
                star.height = 300;
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消 fill', () => {
            if (star.color === undefined) {
                star.color = "0x00f00f";
            } else {
                star.color = undefined;
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消 虚线(虚线不能填充)', () => {
            if (star.lineType === "full") {
                star.lineType = "dash";
            } else {
                star.lineType = "full";
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消 triangleNum', () => {
            if (star.triangleNum === 5) {
                star.triangleNum = 10;
            } else {
                star.triangleNum = 5;
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消 fillColor', () => {
            if (star.style.fillGradientType !== 1) {
                star.style.fillGradientType = 1
                star.style.fillGradientStops = [0, 0.5, 0.5, 1] // 渐变分布
                star.style.fillColor = [[255, 0, 0, 1], [0, 255, 0, 1], [0, 0, 255, 1], [0, 0, 0, 1]];
            } else {
                star.style.fillGradientType = 0
                star.style.fillGradientStops = [0, 0.5, 0.5, 1] // 渐变分布
                star.style.fillColor = [[255, 0, 0, 1], [0, 255, 0, 1], [0, 0, 255, 1], [0, 0, 0, 1]];
            }

        }, uiStage, 15, 0);
    }

    private posY = 15;
    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, fun);
        target.addChild(button);
        this.posY = this.posY + 25 + y;
    }
}

